import React from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import { Trans } from "react-i18next";


export const Insight = ({ html_insight, author }) => {
    if (!html_insight) {
        return null;
    }

    return <div className="scp-embed-post-insight scp-p-2 scp-rounded-sm scp-shadow-sm scp-border-l-4 scp-border-gray-300" style={{ borderLeftStyle: "solid" }}>
        <div className="scp-embed-post-insight-author scp-text-sm">
            <Trans i18nKey="author_s_insight">
                <a className="scp-embed-link" href={author.url}>{{ name: author.name }}</a>'s insight:
            </Trans>
        </div>
        <InsightText dangerouslySetInnerHTML={{ __html: html_insight }} className="scp-embed-post-insight-text" />
    </div>
}
const InsightText = styled.div`
    p {
        margin: 0;
    }
`;


const addClasses = classes => ({ className }) => ({
    className: className && className + " " + classes || classes
})
export const Title = ({ href, children }) => <a
    href={href}
    target="_blank"
    className={"scp-embed-post-title scp-embed-link scp-text-xl"}
>{children}</a>

export const Description = styled.div.attrs(addClasses("scp-embed-post-description"))`
    blockquote {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: inherit;
        &::before {
            content: "\u201C";
        }
        &::after {
            content: "\u201D";
        }
        &::before, &::after {
            position: initial;
            font-size: inherit;
            font-family: inherit;
            line-height: inherit;
        }
    }
    img {
        max-width: 100% !important;
        height: auto !important;
    }
    p {
        margin: 0;
    }
`;

export const Meta = ({ url, publication_date_ms }) => {
    let date = dayjs(publication_date_ms);
    return <div className="scp-text-xs scp-embed-post-meta">
        <MetaDomain url={url} />
        {date.format("LLL")}
    </div>
}

const MetaDomain = ({ url }) => {
    if (!url) {
        return null;
    }
    try {
        const root = new URL("/", url);
        return <React.Fragment>
            <a href={root} className="scp-embed-link" target="_blank">{root.host}</a>&nbsp;-&nbsp;
        </React.Fragment>

    } catch (e) {
        console.warn(e);
        return null;
    }

}

export const LinkImage = ({ src, ...props }) => <LinkImageInner
    style={{ backgroundImage: `url('${src}')` }}
    {...props} />

const LinkImageInner = styled.a.attrs(addClasses("scp-embed-post-image"))`
    display: block;
    background-position: center;
    background-size: cover;
`;